import React from 'react';
import { motion } from 'framer-motion';

const ageData = [
    { label: '20代', value: 2, color: 'bg-gray-400 dark:bg-gray-500' },
    { label: '30代', value: 6, color: 'bg-gray-500 dark:bg-gray-400' },
    { label: '40代', value: 7, color: 'bg-gray-600 dark:bg-gray-300' },
    { label: '50代', value: 4, color: 'bg-gray-700 dark:bg-gray-200' },
];

const Stats = () => {
    return (
        <section id="team" className="py-20 bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
            <div className="container mx-auto px-4 md:px-6">
                <div className="text-center mb-16">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">数字で見る Project NEXUS メンバー構成</h2>
                    <p className="text-gray-600 dark:text-gray-300">※2026年09月時点</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
                    {/* Key Metrics */}
                    <div className="grid grid-cols-2 gap-6">
                        <motion.div
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            className="bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-lg text-center"
                        >
                            <div className="text-5xl font-bold text-gray-900 dark:text-white mb-2">19</div>
                            <div className="text-gray-600 dark:text-gray-300 font-medium">メンバー数</div>
                        </motion.div>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ delay: 0.1 }}
                            className="bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-lg text-center"
                        >
                            <div className="text-5xl font-bold text-gray-900 dark:text-white mb-2">20<span className="text-2xl">年</span></div>
                            <div className="text-gray-600 dark:text-gray-300 font-medium">平均業界経験年数</div>
                        </motion.div>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ delay: 0.2 }}
                            className="bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-lg text-center"
                        >
                            <div className="text-5xl font-bold text-gray-900 dark:text-white mb-2">15</div>
                            <div className="text-gray-600 dark:text-gray-300 font-medium text-sm">外資系IT企業<br />在籍/経験</div>
                        </motion.div>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ delay: 0.3 }}
                            className="bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-lg text-center"
                        >
                            <div className="text-5xl font-bold text-gray-900 dark:text-white mb-2">9</div>
                            <div className="text-gray-600 dark:text-gray-300 font-medium text-sm">データサイエンス<br />業務経験</div>
                        </motion.div>
                    </div>

                    {/* Age Distribution Chart */}
                    <div className="bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-lg">
                        <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-6">年代構成</h3>
                        <div className="space-y-4">
                            {ageData.map((item, index) => (
                                <div key={index} className="flex items-center gap-4">
                                    <div className="w-12 text-gray-600 dark:text-gray-300 font-medium">{item.label}</div>
                                    <div className="flex-1 h-8 bg-gray-100 dark:bg-gray-700 rounded-full overflow-hidden">
                                        <motion.div
                                            initial={{ width: 0 }}
                                            whileInView={{ width: `${(item.value / 8) * 100}%` }}
                                            transition={{ duration: 1, delay: 0.2 }}
                                            className={`h-full ${item.color} relative`}
                                        >
                                            <span className="absolute right-2 top-1/2 -translate-y-1/2 text-xs font-bold text-white dark:text-gray-900">
                                                {item.value}
                                            </span>
                                        </motion.div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Stats;
